import styles from './styles.module.scss';

const LoadingSpinner = () => {
  return <div className={styles.loadingSpinner}></div>;
};

export default LoadingSpinner;
